import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("✅ 로그인 성공!");
      navigate("/");
    } catch (error) {
      alert("❌ 로그인 실패: " + error.message);
    }
  };

  return (
    <div className="loginPage">
      <h2>로그인</h2>
      <form onSubmit={handleLogin}>
        <input type="email" placeholder="이메일" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input type="password" placeholder="비밀번호" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <button type="submit">로그인</button>
      </form>
      <p><Link to="/reset-password">비밀번호를 잊으셨나요?</Link></p>
      <p>계정이 없으신가요? <Link to="/signup">회원가입</Link></p>
    </div>
  );
};

export default Login;
